export class EmbeddedStoreManager{
    storeManagerAlternativeEmail1: string;
    storeManagerAlternativeEmail2: string;
    storeManagerBiography: string;
    storeManagerEmail: string;
    storeManagerEmailXml: string;
    storeManagerGoogleProfile: string;
    storeManagerName: string;
    storeManagerSurname: string;
    storeManagerTelephone: string;
    constructor(){
        this.storeManagerAlternativeEmail1 = "";
        this.storeManagerAlternativeEmail2 = "";
        this.storeManagerBiography = "";
        this.storeManagerEmail = "";
        this.storeManagerGoogleProfile = "";
        this.storeManagerName = "";
        this.storeManagerSurname = "";
        this.storeManagerTelephone = "";
        this.storeManagerEmailXml = "";
    }
}